"use strict";

var moduleName = "add-remove-required";

module.exports = function () {
	$("body").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Добавляем/Убираем required к полю "Укажите адрес доставки"
		//

		$(".jsFormOrder").change(function() {
			if($("#delivery").is(":checked")) {
				$(".jsFieldAddress").attr("required", true);
			} else {
				$(".jsFieldAddress").removeAttr("required");
			}
		});

		
		
	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/addRemoveRequiredInit.js
 **/